import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_Settings from "../../../../layout/menu/sections/settings/settings";
import SettingsSearch from "../../../../layout/search/sections/settings/settings-search";
import {GroupedData} from "../../../data-structures/group";
import {UIType} from "../../../../layout/ui/@const";

export class SpaceSettings extends SpaceProto {

    constructor() {
        super(NavigationSectionType.SETTINGS)

        this.title      = "Settings"

        this.svgIcon    = 'isvg-settings'

        this.defaultPosition   = NavigationButtonPosition.MORE


        switch (gd.ui.type) {

            case UIType.ASANA:
            case UIType.TEAMS:
                this.positions = []
                break

            case UIType.TOP:
                this.positions = [NavigationButtonPosition.TOP, NavigationButtonPosition.MORE]
                break

            default:
                this.positions = [NavigationButtonPosition.TOP, NavigationButtonPosition.MORE]
                break

        }

    }

    onClick = () => {

        if (!this.navigation.defaultAppUrl) {
            this.navigation.defaultAppUrl = 'settings/organization-all'
        }

        navigationStructureOnClick(this.navigation)
    }

    get navigationPanelLabel():string|null {

        if (gd.ui.type === UIType.ASANA || gd.ui.type === UIType.TEAMS) {
            return null
        }

        return this.title
    }

    get position() {
        // patch
        if (gd.ui.type === UIType.ASANA || gd.ui.type === UIType.TEAMS) {
            return NavigationButtonPosition.STATIC
        }

        return super.position
    }

    set position(position: NavigationButtonPosition) {
        super.position = position
    }

    get enabled(): boolean {
        return true
    }

    get navigationStructureConfig() {

        return {
            id              : this.id,
            icon            : "i5-nav-settings",
            iconActive      : "i5-nav-settings-solid",
            type            : NavigationSectionType.SETTINGS,
            hint            : "Settings",
            renderComponent : Navigation_ButtonGenericDeprecated,
            menuComponent   : MainMenu_Settings,
            onClick         : this.onClick,
            position        : this.position
        }
    }

    search(keyword:string): GroupedData {
        return new SettingsSearch(true, true, true).searchAndGroup(keyword)
    }



}
